import BaseAction from "../../base_action";
import { CREATE_CONTROLS } from '../../../constants'

export default class RisksControlAction extends BaseAction {
  baseUrl = "/__api/v1/risks/"

  createControls = (control_list) => {
    const actionTypes  = CREATE_CONTROLS;
    const url = this.composeUrl(control_list.risk_id, "/controls");
    return this.apiPost(actionTypes, url, control_list);
  }
}



// WEBPACK FOOTER //
// ./src/actions/v2/risks/control.js